import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { PageHeader, Tabs, Button } from "antd";
import Loading from "../../../../components/Loading";
import Cfop from "../Cfop";
import TableSynthetic from "./Synthetic";
import TableAnalytical from "./Analytical";
import TableDevolution from "./Analytical/tableDevolution";
import CfopView from "./Cfop";
import {
  getResult,
  downloadConsideredReport,
  downloadDevolutionConsideredReport,
} from "../actions";
import { createLoadingSelector } from "../../../../store/api/selectors";
import { numberToReal, maskCnpj } from "../../../../helpers/functions";

const TabPane = Tabs.TabPane;

class ViewResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: {
        RazaoSocial: JSON.parse(sessionStorage.getItem("eRecuperadorCompany"))
          .RazaoSocial,
        Cnpj: JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj,
      },
      idResult: null,
      plots: {},
      listCfop: [],
    };
  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    this.setState({ idResult: id, hasSegregation: false });

    if (id) {
      await this.props.getResult(id);
    }
  }

  componentDidUpdate(prevProps) {
    const { result } = this.props;

    if (prevProps.result !== result) {
      if (
        !!(
          result &&
          result.resultadoPisCofins &&
          result.resultadoPisCofins.StatusExecucao === 2
        )
      ) {
        this.setState({
          activeTab: "2",
        });
      } else {
        this.setState({
          activeTab:
            result &&
            result.resultadoPisCofins &&
            result.resultadoPisCofins.ControleApuracao &&
            result.resultadoPisCofins.ControleApuracao.ExisteApuracao
              ? "1"
              : "2",
        });
      }

      this.getPlots(result.tributosResultadoPisCofins);

      this.createNewList();
    }
  }

  createNewList() {
    const { result } = this.props;
    let listCfop = result.CfopMovimentacao ? [...result.CfopMovimentacao] : [];

    result &&
      (result.tributosResultadoPisCofins || []).map((item) => {
        if (item.Status === 10) {
          return listCfop.push({
            Cfop: "-",
            ConsideraReceita: true,
            Grupo: "OUTRAS RECEITAS",
            Valor: item.ValorParcela,
            ValorDesconto: 0,
            ValorFrete: 0,
            ValorAcrescido: item.ValorAcrescido,
            ValorOutrasDespesas: item.ValorOutrasDespesas,
            ValorTotal: item.ValorParcela,
          });
        }
        return listCfop;
      });

    listCfop = listCfop.map((item) => {
      return {
        ...item,
        Cfop: item.Cfop ? item.Cfop : "-",
        Valor: numberToReal(item.Valor),
        ValorDesconto: numberToReal(item.ValorDesconto),
        ValorFrete: numberToReal(item.ValorFrete),
        ValorAcrescido: numberToReal(item.ValorAcrescido),
        ValorOutrasDespesas: numberToReal(item.ValorOutrasDespesas),
        ValorTotal: numberToReal(item.ValorTotal),
      };
    });

    this.setState({ listCfop });
  }

  changeActiveTab(key) {
    this.setState({ activeTab: key });
  }

  getPlots(data) {
    return (
      data &&
      data.map((item) => {
        switch (item.Status) {
          case 1:
            return this.setState((prevState) => ({
              plots: {
                ...prevState.plots,
                totalStatus1: numberToReal(item.ValorParcela),
              },
            }));
          case 7:
            return this.setState((prevState) => ({
              plots: {
                ...prevState.plots,
                totalStatus7: numberToReal(item.ValorParcela),
              },
            }));
          case 8:
            return this.setState((prevState) => ({
              plots: {
                ...prevState.plots,
                totalStatus8: numberToReal(item.ValorParcela),
              },
            }));
          case 9:
            return this.setState((prevState) => ({
              plots: {
                ...prevState.plots,
                totalStatus9: numberToReal(item.ValorParcela),
              },
            }));
          case 10:
            return this.setState((prevState) => ({
              plots: {
                ...prevState.plots,
                totalStatus10: numberToReal(item.ValorParcela),
              },
            }));
          default:
            return this.state.plots;
        }
      })
    );
  }

  renderReportsButtom(key, resultPeriod) {
    switch (key) {
      case "1":
        return (
          <Button className="btn-print no-print" onClick={() => window.print()}>
            <i className="fas fa-print mr-2" /> Imprimir
          </Button>
        );
      case "2":
        return (
          <Button
            className="btn-print no-print"
            onClick={() => this.props.downloadConsideredReport(resultPeriod)}
          >
            <i className="fas fa-download mr-2" /> Baixar relatório
          </Button>
        );
      case "4":
        return (
          <Button
            className="btn-print no-print"
            onClick={() =>
              this.props.downloadDevolutionConsideredReport(resultPeriod)
            }
          >
            <i className="fas fa-download mr-2" /> Baixar relatório
          </Button>
        );
      default:
        return null;
    }
  }

  onClickBack = () => {
    const { company } = this.state;
    const { history, location } = this.props;

    let pageEnviar = 1
    let pageSizeEnviar = 12

    if(location.state){
      pageEnviar = location.state.currentPage || 1
      pageSizeEnviar = location.state.currentPageSize || 12
    }

    history.push({              
      pathname: `/empresa/${company.Cnpj}`,
      state: { currentPage: pageEnviar, currentPageSize: pageSizeEnviar }
    })
  }

  render() {
    const { company, idResult, plots, activeTab, listCfop } = this.state;
    const { history, result, isFetching } = this.props;

    const resultPeriod = !!Object.entries(result).length && {
      month: result.resultadoPisCofins.ControleApuracao.Mes,
      year: result.resultadoPisCofins.ControleApuracao.Ano,
    };
    const viewCfop = !!(
      !!Object.entries(result).length &&
      result.resultadoPisCofins &&
      result.resultadoPisCofins.ValidarCfop &&
      (!result.resultadoPisCofins.StatusExecucao ||
        result.resultadoPisCofins.StatusExecucao === 4 ||
        result.resultadoPisCofins.StatusExecucao === 5 ||
        result.resultadoPisCofins.StatusExecucao === 6 ||
        result.resultadoPisCofins.StatusExecucao === 7 ||
        result.resultadoPisCofins.StatusExecucao === 8 ||
        result.resultadoPisCofins.StatusExecucao === 9 ||
        result.resultadoPisCofins.StatusExecucao === 10 ||
        result.resultadoPisCofins.StatusExecucao === 11 ||
        result.resultadoPisCofins.StatusExecucao === 13 ||
        result.resultadoPisCofins.StatusExecucao === 14 ||
        result.resultadoPisCofins.StatusExecucao === 15 ||
        result.resultadoPisCofins.StatusExecucao === 16 ||
        result.resultadoPisCofins.StatusExecucao === 17 ||
        result.resultadoPisCofins.StatusExecucao === 18 ||
        result.resultadoPisCofins.StatusExecucao === 19)
    );

    if (!viewCfop && Object.entries(result).length) {
      return (
        <>
          <PageHeader
            onBack={this.onClickBack}
            title={company.RazaoSocial}
            subTitle={`${maskCnpj(company.Cnpj)} | Período: ${
              resultPeriod.month
            }/${resultPeriod.year}`}
          />

          <section className="segregation pb-5 px-3">
            {isFetching ? <Loading /> : null}
            {this.renderReportsButtom(activeTab, resultPeriod)}
            {/* {activeTab !== "3" ? (
                            <>

                                {activeTab === "1" ? (
                                    <Button
                                        className="btn-print no-print"
                                        onClick={() => window.print()}
                                    >
                                        <i className="fas fa-print mr-2" /> Imprimir
                                    </Button>
                                ) : (
                                        <Button
                                            className="btn-print no-print"
                                            onClick={() =>
                                                this.props.downloadConsideredReport(resultPeriod)
                                            }
                                        >
                                            <i className="fas fa-download mr-2" /> Baixar relatório
                                        </Button>
                                    )}
                            </>
                        ) : null} */}

            <Tabs
              className="ant-tabs--custom"
              activeKey={activeTab}
              type="card"
              onChange={(e) => this.changeActiveTab(e)}
            >
              {!!(
                result &&
                result.resultadoPisCofins &&
                result.resultadoPisCofins.StatusExecucao !== 2
              ) ? (
                <TabPane
                  tab="Apuração do crédito"
                  key="1"
                  disabled={
                    !result.resultadoPisCofins.ControleApuracao.ExisteApuracao
                  }
                >
                  <TableSynthetic id={idResult} data={result} plots={plots} />
                </TabPane>
              ) : null}

              <TabPane tab="Detalhamento das receitas por item" key="2">
                <TableAnalytical period={resultPeriod} />
              </TabPane>

              {result.resultadoPisCofins.ValorTotalDevolucao > 0 ? (
                <TabPane
                  tab="Detalhamento entrada de devolução por item"
                  key="4"
                >
                  <TableDevolution period={resultPeriod} />
                </TabPane>
              ) : null}

              <TabPane tab="CFOP" key="3">
                <CfopView list={listCfop} />
              </TabPane>
            </Tabs>
          </section>
        </>
      );
    } else {
      return (
        <>
          <PageHeader
            onBack={this.onClickBack}
            title={company.RazaoSocial}
            subTitle={maskCnpj(company.Cnpj)}
          />

          <section className="segregation pb-5 px-3">
            {isFetching ? <Loading /> : null}
            {Object.entries(result).length ? <Cfop data={result} /> : null}
          </section>
        </>
      );
    }
  }
}

const loadingSelector = createLoadingSelector(["GET_RESULT"]);
const mapStateToProps = (state) => ({
  result: state.results.data,
  isFetching: loadingSelector(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getResult,
      downloadConsideredReport,
      downloadDevolutionConsideredReport,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ViewResult));
